<template>
  <div>
    <my-head></my-head>
    <div class="transferregistration minH">
      <div class="title">发布项目（意向挂牌）</div>
      <Transfer-information :cid="id" :proj-type="1" />
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import TransferInformation from "../components/TransferInformation";
export default {
  name: "transferregistration",
  components: {
    MyHead,
    MyFooter,
    TransferInformation,
  },
  data() {
    return {
      id: null,
    };
  },
  created() {
    this.id = this.$route.query.id;
  },
};
</script>

<style lang="scss">
.transferregistration {
  width: 80%;
  margin: 24px auto 60px;
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
    margin-bottom: 24px;
  }
}
</style>
